import {AnalyticService} from '@/src/ports/services/analytic-service'

declare global {
  interface Window {
    mindbox(mode: 'async', options: {operation: string; data: unknown}): void
  }
}

export class MindboxAnalyticService implements AnalyticService {
  async track(name: string, payload: unknown): Promise<void> {
    if (!(typeof window !== 'undefined' && window.mindbox)) return

    window.mindbox('async', {
      operation: name,
      data: payload,
    })
  }
}
